import React from 'react'
import './virtualCard.css'
export default function VirtualCard() {
  return (
    <div className='virtual-container'>
        <div className="virtual-text">
            <h3>The Smartest Wallet in Your Pocket</h3>
            <p>Say hello to the future of payments. FinFlex’s E-Wallet is designed to simplify your financial life with secure, instant, and flexible transactions all in one place.</p>
            <button><span>Get Started</span> <i class='bx bx-right-arrow-alt' ></i></button>
        </div>
        <div className="virtual-image">
            <img src="assets/E-Wallet-pana.png" alt="" />
        </div>
    </div>
  )
}
